import { useState, useEffect, useCallback } from 'react';
import { useIntl } from 'react-intl';
import debounce from 'lodash/debounce';
import trns from './trns';
import useNotification, { NotificationType } from './useNotification';

export const useNoInternetConnection = () => {
  const intl = useIntl();
  const { showNotification } = useNotification();
  const [isOnline, setOnline] = useState(true);

  useEffect(() => {
    setOnline(navigator?.onLine);
  }, []);

  const setToOnline = () => setOnline(true);
  const setToOffline = () => setOnline(false);

  useEffect(() => {
    window.addEventListener('online', setToOnline);
    window.addEventListener('offline', setToOffline);
    return () => {
      window.removeEventListener('online', setToOnline);
      window.removeEventListener('offline', setToOffline);
    };
  }, []);

  const debouncedShowNotification = useCallback(
    debounce(() => {
      showNotification({
        message: intl.formatMessage(trns.noInternetConnect),
        type: NotificationType.Error,
        id: 'noInternetConnectionToast'
      });
    }, 250),
    [showNotification]
  );

  useEffect(() => {
    if (!isOnline) {
      debouncedShowNotification();
    }
  }, [isOnline]);
};
